import { classifyInvoiceLine, interpretOperationalUnit } from "./classifyLine";
import { extractInvoiceHeaderContext } from "./extractHeader";
import { extractInvoiceLines, extractInvoiceMetadata } from "./extractMetadata";
import { parseInvoiceLines } from "./parseLines";
import type { ParsedInvoiceDraft, ParsedInvoiceLine } from "./types";

function lineId(sourceFilename: string, index: number): string {
  return `${sourceFilename}:${index}`;
}

export function parseInvoiceText(sourceFilename: string, text: string): ParsedInvoiceDraft {
  const { client, project } = extractInvoiceHeaderContext(text);
  const metadata = extractInvoiceMetadata(text);
  const rawLines = extractInvoiceLines(text);
  const structured = parseInvoiceLines(rawLines);
  const warnings = [...metadata.warnings];

  if (structured.length === 0) warnings.push("No invoice line items detected between SERVICE INFO and Subtotal.");

  const lines: ParsedInvoiceLine[] = structured.map((item, index) => {
    const { classification, needsReview } = classifyInvoiceLine(item.name, item.rawLine);
    const interpretedUnit = interpretOperationalUnit(item.name, item.unit);
    const ambiguousUnit = item.quantity > 0 && !interpretedUnit && !item.unit;
    return {
      id: lineId(sourceFilename, index),
      rawLine: item.rawLine,
      name: item.name,
      description: item.rawNotes,
      rawQuantity: item.quantity,
      rawUnitLabel: item.unit,
      interpretedUnit,
      unitPrice: item.unitPrice,
      lineTotal: item.totalPrice,
      classification,
      needsReview: needsReview || ambiguousUnit,
      rawNotes: item.rawNotes,
    };
  });

  return {
    sourceFilename,
    clientName: client.name,
    clientEmail: client.email,
    clientPhone: client.phone,
    invoiceNumber: metadata.invoiceNumber,
    invoiceIssueDate: metadata.invoiceIssueDate,
    projectName: project.name,
    eventType: project.eventType,
    eventDate: project.eventDate,
    venue: project.location,
    lines,
    subtotal: metadata.subtotal,
    invoiceTotal: metadata.invoiceTotal,
    paymentSchedule: metadata.paymentSchedule,
    parseWarnings: warnings,
  };
}
